(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.setup-carousel').forEach((carousel) => {
    const track = carousel.querySelector('.setup-track');
    const cards = [...track.children];
    let index = 0;
    let timer;
    let visible = false;
    const markVisible = () => cards.forEach((card, i) => {
      card.setAttribute('aria-hidden', String(i !== index && i !== index + 1));
    });
    const resetLoop = () => {
      if (index !== 3) return;
      track.style.transition = 'none';
      index = 0;
      track.style.transform = 'translateX(0)';
      markVisible();
      // Commit the identical first pair before re-enabling animation.
      void track.offsetWidth;
      track.style.transition = '';
    };
    const updateTimer = () => {
      clearInterval(timer);
      if (!visible || document.hidden || reducedMotion.matches) return;
      timer = setInterval(() => {
        resetLoop();
        index += 1;
        track.style.transform = `translateX(-${index * 50}%)`;
        markVisible();
      }, 4000);
    };
    track.addEventListener('transitionend', (event) => {
      if (event.target === track && event.propertyName === 'transform') resetLoop();
    });
    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      updateTimer();
    }, { threshold: 0.1 }).observe(carousel);
    document.addEventListener('visibilitychange', updateTimer);
    reducedMotion.addEventListener('change', () => {
      resetLoop();
      updateTimer();
    });
    markVisible();
  });
})();
